import http from "@/http/aisea/axios";
const resource = "/enterprises/operations/workflows";

const operationWorkflowRepository = {
  /**
   * APIでoperationのWorkflow一覧を取得する
   * @returns {Promise<Object>}
   * @property {boolean} status - APIのリクエストが成功したかどうか
   * @property {number} code - ステータスコード
   * @property {OperationWorkflow[]} data - データ
   * @property {string} message - メッセージ
   *  @throws {Error}
   */
  index() {
    return http.get(`${resource}`);
  },
};

export default operationWorkflowRepository;
